"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = exports.VideoResource = void 0;
var _react = _interopRequireDefault(require("react"));
var _createResource = require("./createResource");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var VideoResource = (0, _createResource.createResource)(function (src) {
  return new Promise(function (resolve, reject) {
    var video = document.createElement('video');
    video.src = src;
    video.oncanplay = function () {
      resolve(video);
    };
    video.onerror = reject;
  });
});
exports.VideoResource = VideoResource;
var Video = function Video(props) {
  VideoResource.read(props.src);
  return _react.default.createElement("video", props);
};
exports.Video = Video;